import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SearchX: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm13.5 8.5-5 5' }],
    ['path', { d: 'm8.5 8.5 5 5' }],
    ['circle', { cx: '11', cy: '11', r: '8' }],
    ['path', { d: 'm21 21-4.3-4.3' }],
  ],
];

export default SearchX;
